import React from "react";
import styled from "styled-components";

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
`;

const PageButton = styled.button`
  padding: 6px 12px;
  /* border: 1px solid #ccc; */
  border: none;
  border-radius: 4px;
  background-color: ${(props) => (props.active ? "#ffc20e" : "white")};
  color: ${(props) => (props.active ? "white" : "black")};
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background-color: #ffc20e;
    color: white;
  }

  &:disabled {
    background-color: #eee;
    color: #999;
    cursor: not-allowed;
    border-color: #ddd;
  }
`;

const PageButton2 = styled.button`
  padding: 6px 12px;
  border: none;
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  background-color: ${(props) => (props.active ? "#ffc20e" : "white")};
  color: ${(props) => (props.active ? "white" : "black")};
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background-color: #ffc20e;
    color: white;
  }
`;

export const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <PaginationWrapper>
      {currentPage > 1 && (
        <PageButton2 onClick={handlePrev}>{"< Prev"}</PageButton2>
      )}

      {pageNumbers.map((number) => (
        <PageButton
          key={number}
          active={number === currentPage}
          onClick={() => onPageChange(number)}
        >
          {number}
        </PageButton>
      ))}

      {currentPage < totalPages && (
        <PageButton2 onClick={handleNext}>{"Next >"}</PageButton2>
      )}
    </PaginationWrapper>
  );
};

export default Pagination;
